import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css"; // Ensure Skeleton styles are loaded

const Card = ({
  mode,
  loading,
  title,
  Icon,
  className,
  count
}) => {

  return (
    <>
      {loading ? (
        <Skeleton
          count={4}
          height={40}
          baseColor={mode === "dark" ? "#010101" : "#f9f9f9"}
          highlightColor={mode === "dark" ? "#1a1c23" : "#f8f8f8"}
        />
      ) : (
        <div
          className={`card text-center mb-4 cursor-pointer text-white  ${className}  p-2`}
          style={{ cursor: "pointer" }}
        >
          <div className="card-body">
            <div className="mb-3">
              <div className="fs-2  mb-2" style={{ color: "white" }}>
                <Icon />
              </div>
              <h5 className="card-subtitle mb-2 p-2 text-muted12" style={{ color: "white" }}>
                <b> {title} </b>
              </h5>
              <h3 className="card-title fw-bold">
                {count}
              </h3>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Card;
